import type { ResourceSection } from '@domain/schemas/contract.schema';
import { ENDORSEMENT_DETAILS_SENTINEL } from '@domain/schemas/endorsement-summary.schema';

export interface EndorsementDetailsNavItem {
  id: typeof ENDORSEMENT_DETAILS_SENTINEL;
  label: string;
  endorsementDetailsSections: ResourceSection[];
}

export type NavItem = ResourceSection | EndorsementDetailsNavItem;

export function isEndorsementDetailsNavItem(item: NavItem): item is EndorsementDetailsNavItem {
  return item.id === ENDORSEMENT_DETAILS_SENTINEL;
}
